import { SafeHtml } from '@angular/platform-browser';

export const Older_Notifications ='older';
export const Notification_TimeInterval= 300000;
export const SearchMinLengthChars= 3;
export const UnRead_Notifications_PlaceHolder ='Search unread notifications';
export const All_Notifications_PlaceHolder ='Search all notifications';


export interface InAppNotification {
  id: number;
  type: string;
  template: string;
  content: Record<string, string>;
  createdOn: string;
  isRead: boolean;
  notificationSafeHtml?: SafeHtml;
  notificationId: number;
  notificationPlaceholderContent: string;
}

export interface InAppNotificationModel {
  recentNotifications: InAppNotification[];
  olderNotifications:InAppNotification[];
  totalUnreadCount: number;
}
export interface InAppNotificationsPayload {
  searchTerm: string | null;
  lastSyncedTime: Date | null;
  recipientStatus:NotificationRecipientStatus | null;
}

export interface InAppNotificationsLatestStatus {
  hasUnread: boolean;
  hasRecent: boolean;
}

export enum NotificationRecipientStatus
{
    Unread,
    Read
}

export const tokenValueMap: Record<string, string> = {
  '$$DealNameLink$$': 'dealNameLink',
  '$$ClientName$$': 'clientName',
  '$$Date$$': 'date',
  '$$CompanyName$$': 'companyName',
  '$$ISDealName$$': 'iSDealName',
  '$$DealID$$': 'dealId',
  '$$DealUrl$$': 'dealUrl',
  '$$Link$$': 'link',
  '$$DealName$$': 'dealName',
  '$$CompanyNameLink$$': 'companyNameLink',
  '$$ClientNameLink$$': 'clientNameLink',
  '$$NoOfReceivedDocuments$$': 'noOfReceivedDocuments',
  '$$DateOfDocumentUpload$$':'dateOfDocumentUpload'
};

